import React from "react";
import Grid from "@mui/material/Grid";
import { ReactGoogleReviews } from "react-google-reviews";
import Rating from "@mui/material/Rating";
import "react-google-reviews/dist/index.css";


const Reviews = ({ reviews, reviewsRating, reviewsTotal }) => {
	// Transform raw reviews to expected format and filter out 1 and 2 star reviews
	const transformedReviews = reviews && Array.isArray(reviews)
		? reviews
			.filter(raw => Number(raw.rating) > 2)
			.map(raw => ({
				reviewId: raw.review_id || null,
				reviewer: {
					isAnonymous: !raw.author_name,
					displayName: raw.author_name || "Anonymous",
					profilePhotoUrl: raw.profile_photo_url || ""
				},
				starRating: raw.rating || 0,
				createTime: raw.time ? new Date(raw.time * 1000).toISOString() : null,
				updateTime: raw.time ? new Date(raw.time * 1000).toISOString() : null,
				comment: raw.text || ""
			}))
		: [];

	// Use the passed-in stats from Profile.js (from placeData)
	const totalReviews = typeof reviewsTotal === 'number' ? reviewsTotal : 0;
	const averageRating = typeof reviewsRating === 'number' || typeof reviewsRating === 'string' ? reviewsRating : null;

	// Responsive padding
	const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
	const containerPadding = isMobile ? '60px 15px' : '60px 60px';

	return (
		<Grid container style={{ padding: containerPadding }}>
			<Grid size={12}>
				<h3 style={{ margin: 0, marginBottom: 30, fontSize: "26px", paddingLeft: isMobile ? 15 : 0, paddingRight: isMobile ? 15 : 0 }}>
					Ratings & Reviews
				</h3>
			</Grid>
			<Grid size={12} style={{ padding: 0 }} className="reviews-container">
				<ReactGoogleReviews layout="carousel" reviews={transformedReviews} />
			</Grid>
			<Grid size={12} style={{ marginTop: 18, display: 'flex', justifyContent: 'center' }}>
				{totalReviews > 0 && averageRating ? (
					<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontWeight: 500, marginBottom: 10 }}>
						<div style={{ display: 'flex', alignItems: 'center', fontWeight: 700 }}>
							<span style={{ color: '#fbc02d', fontSize: 22 }}>{averageRating}</span>
							<Rating
								name="read-only"
								value={Number(averageRating)}
								precision={0.1}
								readOnly
								size="medium"
								style={{ marginLeft: 10 }}
							/>
						</div>
						<a
							href="#reviews-all"
							style={{ color: '#888', fontSize: 13, textDecoration: 'none', marginTop: 10 }}
						>
							Show all {totalReviews} review{totalReviews !== 1 ? 's' : ''}
						</a>
					</div>
				) : (
					<span style={{ color: '#888', fontSize: 16 }}>No reviews yet</span>
				)}
			</Grid>
		</Grid>
	);
};

export default Reviews;
